import React, { useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import ImageComponent from "../ImageComponent";
import { updateUserProfile } from "../../services/authAPI";
import { toast } from "react-toastify";
import { handleApiError } from "../../services/errorHandler";
import Avatar from "../choose-avatar-components/Avatar";

const UnblockComponent = ({
  user,
  toggleMenu,
  selectedUser,
  accessToken,
  userProfileData,
  blockedUsers,
  refetchProfile,
}) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const callUpdateEventAPI = async (updates) => {
    setIsUpdating(true);
    const bodyParams = {
      accessToken: accessToken,
      username: userProfileData.userID,
      ...updates,
    };

    try {
      const response = await updateUserProfile(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          toast.success("User unblocked successfully");
          await refetchProfile();
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsUpdating(false);
    }
  };
  const handleUnblockUser = (userID) => {
    // Add the new user to the existing list of blocked users
    const updatedBlockedUsers = blockedUsers.filter(
      (blockedUserID) => blockedUserID !== userID
    );

    // Call the API with the updated list
    callUpdateEventAPI({ blockedUsers: updatedBlockedUsers });
  };
  return (
    <View
      key={user.id}
      style={{
        width: 60,
      }}
    >
      <TouchableOpacity
        style={[{ alignItems: "center", position: "relative" }]}
        onPress={() => toggleMenu(user)}
      >
        {/* <ImageComponent
          url={
            user?.profilePicture
              ? user?.profilePicture
              : AppImages.icProfilePlaceHolder
          }
          style={[
            {
              resizeMode: "contain",
              width: 49,
              height: 49,
              borderRadius: "50%",
            },
            selectedUser === user && {
              borderColor: "red",
              borderWidth: 2,
            },
          ]}
        /> */}
        <View
          style={[
            {},
            selectedUser === user && {
              borderColor: "red",
              borderWidth: 2,
              borderRadius: 50,
            },
          ]}
        >
          <Avatar
            src={
              user?.profilePicture
                ? user?.profilePicture
                : AppImages.icProfilePlaceHolder
            }
            variant="blockUser"
          />
        </View>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            {
              color: AppColors.gray_C3C3C3,
              marginTop: 5,
              width: 60,
              textAlign: "center",
            },
          ]}
        >
          {user.userID ? user.userID : ""}
        </Text>

        {selectedUser === user && (
          <View
            style={{
              position: "absolute",
              marginTop: 10,
              top: 60,
              left: 0,
              backgroundColor: AppColors.black,
              borderWidth: 2,
              borderColor: AppColors.white,
              zIndex: 999,
            }}
          >
            <TouchableOpacity onPress={() => handleUnblockUser(user.userID)}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_10,
                  {
                    color: AppColors.green_4CD964,
                    padding: 10,
                  },
                ]}
              >
                Unblock
              </Text>
            </TouchableOpacity>
          </View>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default UnblockComponent;
